import { componentFactory } from 'vue-tsx-support';

type Source = {
  srcset: string;
  type?: string;
  media?: string;
};

export default componentFactory.create({
  name: 'JtnUiPicture',
  props: {
    sources: {
      type: Array as () => Source[],
      default: []
    }
  },
  render() {
    return (
      <picture>
        {this.sources.map(source => (
          <source {...{ attrs: source }} />
        ))}
        {this.$slots.default}
      </picture>
    );
  }
});
